import React from 'react';

import { Card, Col, Form, Row, Button, InputGroup, Spinner } from 'react-bootstrap';
import PropTypes from 'prop-types';
import paths from 'routes/paths';
import { useState } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from "axios";
import moment from "moment";
import { toast } from 'react-toastify';
import MedicalRecordModal from './MedicalRecordModal';
import CommonBreadCrumb from 'components/commonbreadcrumb/CommonBreadCrumb';
import SpecialInstructionInput from 'components/prescription/SpecialInstructionInput';
import ThemedSelect from 'components/commonbreadcrumb/ThemedSelect';
import ShimmerUI from 'components/ShimmerUI/PatientShimmer';

const AddEditMedicalRecord = () => {
    const location = useLocation();
    const locationData1 = location?.state;
    const dataObj = locationData1?.dataObj;
    const flagsObj = locationData1?.flagsObj;
    let initialFormData = {
        facilityname: '',
        individual: '',
        category: '',
        description: flagsObj?.description || '',
        callhcp: '',
        splins: '',
        orderid: '',
        hcp: '',
        startdate: '',
        stopdate: '',
        frequency: '',
        rsn: '',
        medgrp: '',
        is_medsheet: true,
        is_treatment: true,
        is_physpres: true,
        is_prnmedication: false,
        is_active: true,
        time1: '0',
        time2: '0',
        time3: '0',
        time4: '0',
        time5: '0',
        time6: '0',
        time7: '0',
        time8: '0',
        special_instruction_text: ''
    };

    const [formData, setFormData] = useState(initialFormData);

    const [checked, setChecked] = useState(false);
    const [edittimeclicked, setEditTimeClicked] = useState(false);
    const [showIsDiscModal, setShowIsDiscModal] = useState(false);
    const [pendingIsDiscontinued, setPendingIsDiscontinued] = useState(null); // true = discontinue, false = activate

    const [startdate, setStartDate] = useState(null);
    const [stopdate, setStopDate] = useState(null);
    const [patientName, setPatientName] = useState(localStorage.getItem("patientName"));
    const [loader, setLoader] = useState(false);
    const [showShimmer, setShowShimmer] = useState(false);
    const [time1options, setTime1] = useState([]);
    const [time2options, setTime2] = useState([]);
    const [time3options, setTime3] = useState([]);
    const [time4options, setTime4] = useState([]);
    const [time5options, setTime5] = useState([]);
    const [time6options, setTime6] = useState([]);
    const [time7options, setTime7] = useState([]);
    const [time8options, setTime8] = useState([]);

    const [facilityoptions, setFacilityOptions] = useState([]);
    const [patientoptions, setPatientOptions] = useState([]);
    const [hcpoptions, setHcpOptions] = useState([]);
    const [splInsOptions, setSplinsOptions] = React.useState([]);
    const [freqOptions, setFreqOptions] = React.useState([]);
    const [presOptions, setPresOptions] = React.useState([]);
    const [medgroupOptions, setMedGroupOptions] = React.useState([]);
    const [medcategoryOptions, setMedCategoryOptions] = React.useState([]);
    const [errors, setErrors] = useState({});
    const [selectedFreq, setSelectedFreq] = useState(null);
    const { id } = useParams()
    const [locationData, setLocationData] = useState({
        medrecord_id: id,
    });
    const [disableDFlag, setDisableFlag] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        populateData();
    }, []);

    async function populateData() {
        let fId = ''
        let presId = null
        let pID = null
        let tokenStr = localStorage.getItem("accessToken");
        let results = JSON.parse(localStorage.getItem("facilitiesData"));
        //console.log("locationData.medrecord_id " + locationData.medrecord_id);

        setFacilityOptions([
            { key: 'Select a facility', value: '' },
            ...results
        ]);

        await axios.get(`${process.env.REACT_APP_SERVER_URL}/patients/list-medical-record-category`, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
            .then(async (res) => {

                let objMedicalRecordCategoryData = res.data.data;

                let medCategoryResults = [];

                objMedicalRecordCategoryData.forEach((singleRec) => {
                    medCategoryResults.push({
                        key: singleRec.code,
                        value: singleRec.id + '|' + singleRec.mar_flag + '|' + singleRec.tar_flag + '|' + singleRec.po_flag + '|' + singleRec.is_active,
                    });
                });

                setMedCategoryOptions([
                    { key: 'Select Medical Record Category', value: '' },
                    ...medCategoryResults
                ]);


            });

        /**********************ORDERID***********************/
        if (locationData.medrecord_id != null) {

            await axios.get(`${process.env.REACT_APP_SERVER_URL}/patients/get-medical-record/` + locationData.medrecord_id, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
                .then(async (res) => {

                    let objMedicalRecordData = res.data.data;

                    //console.log("singleMedicalRecord " + JSON.stringify(res.data.data));

                    objMedicalRecordData.forEach((singleMedicalRecord) => {
                        fetchHcpData(singleMedicalRecord.facility_id);
                        if (singleMedicalRecord.medication_identifier == "P") {
                            setChecked(true);
                        } else {
                            setChecked(false);
                        }
                        // let freqObj = freqResults.filter((singleFreq) => {
                        //     return Number(singleFreq.value) == Number(singleMedicalRecord.frequency_id);
                        // })
                        // setSelectedFreq(freqObj)
                        presId = singleMedicalRecord.prescription_id;
                        pID = singleMedicalRecord.patient_id;
                        fId = singleMedicalRecord.frequency_id;
                        setPatientName(`${singleMedicalRecord?.patient_last_name}, ${singleMedicalRecord?.patient_first_name}`);
                        setFormData({
                            facilityname: singleMedicalRecord.facility_id,
                            individual: singleMedicalRecord.patient_id,
                            hcp: singleMedicalRecord.doctor_id,
                            category: singleMedicalRecord.medical_record_category_id,
                            callhcp: singleMedicalRecord.other_note,
                            medgrp: singleMedicalRecord.med_group_id,
                            description: singleMedicalRecord.description,
                            rsn: singleMedicalRecord.reason,
                            splins: singleMedicalRecord.special_instruction_id,
                            frequency: singleMedicalRecord.frequency_id,
                            orderid: singleMedicalRecord.prescription_id,
                            is_medsheet: Number(singleMedicalRecord.mar_flag) == 1 ? true : false,
                            is_treatment: Number(singleMedicalRecord.tar_flag) == 1 ? true : false,
                            is_physpres: Number(singleMedicalRecord.po_order) == 1 ? true : false,
                            is_active: Number(singleMedicalRecord.is_active) == 1 ? true : false,
                            is_prnmedication: singleMedicalRecord.medication_identifier == "P" ? true : false,
                            time1: singleMedicalRecord.time1,
                            time2: singleMedicalRecord.time2,
                            time3: singleMedicalRecord.time3,
                            time4: singleMedicalRecord.time4,
                            time5: singleMedicalRecord.time5,
                            time6: singleMedicalRecord.time6,
                            time7: singleMedicalRecord.time7,
                            time8: singleMedicalRecord.time8,
                            special_instruction_text: singleMedicalRecord.special_instruction_text,
                        });
                        setDisableFlag(singleMedicalRecord.is_active == 0 ? true : false);
                        if (
                            (singleMedicalRecord.time5 && Number(singleMedicalRecord.time5) !== 0) ||
                            (singleMedicalRecord.time6 && Number(singleMedicalRecord.time6) !== 0) ||
                            (singleMedicalRecord.time7 && Number(singleMedicalRecord.time7) !== 0) ||
                            (singleMedicalRecord.time8 && Number(singleMedicalRecord.time8) !== 0)
                        ) {
                            handleMoreTime();
                        }
                        setStartDate(singleMedicalRecord.start_date != null ? moment(singleMedicalRecord.start_date, 'MM/DD/YYYY').format('MM/DD/YY') : null);

                        setStopDate(singleMedicalRecord.stop_date != null ? moment(singleMedicalRecord.stop_date, 'MM/DD/YYYY').format('MM/DD/YY') : null);


                    });
                    let prescriptionResults = JSON.parse(localStorage.getItem("prescriptionObjData"));
                    let prescriptionResultsforPatient = prescriptionResults?.[pID] || [];
                    let presResults = [];
                    if ((prescriptionResults && Object.prototype.hasOwnProperty.call(prescriptionResults, pID))) {
                        prescriptionResultsforPatient?.forEach((value) => {
                            if (value.discontinued_date == null) {
                                presResults.push({
                                    key: value.id + '-' + value.drug,
                                    value: value.id,
                                });
                            }
                        });
                        setPresOptions([
                            { key: 'Select Prescription', value: '' },
                            ...presResults
                        ]);
                    }
                    let getAllItems = (Object.prototype.hasOwnProperty.call(prescriptionResults, pID)) ?
                        {
                            frequency: {},
                            special_instruction: {},
                            medgroup: {},
                            prescription_hour: {}
                        } :
                        {
                            prescription: {
                                patient_id: pID
                            },
                            frequency: {},
                            special_instruction: {},
                            medgroup: {},
                            prescription_hour: {}
                        };

                    await axios.post(`${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`, getAllItems, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
                        .then(async (res) => {
                            /**********************Prescription*****************************/
                            // if (locationData.medrecord_id != null) {
                            //     const prescription = (res?.data?.output?.data?.prescription || [])[0];
                            //     setPatientName(`${prescription?.patient_lastname}, ${prescription?.patient_firstname}`);

                            // }
                            if (!(Object.prototype.hasOwnProperty.call(prescriptionResults, pID))) {
                                let presResultsNew = [];
                                const prescription = (res?.data?.output?.data?.prescription || [])
                                prescription?.forEach((value) => {
                                    if (value.discontinued_date == null) {
                                        presResultsNew.push({
                                            key: value.id + '-' + value.drug,
                                            value: value.id,
                                        });
                                    }
                                });
                                setPresOptions([
                                    { key: 'Select Prescription', value: '' },
                                    ...presResultsNew
                                ]);
                            }

                            /**********************FREQUENCY*****************************/

                            let objFreqData = res?.data?.output?.data["frequency"];
                            let freqResults = [];

                            objFreqData?.forEach((value) => {
                                if (value.name != null && value.name != "") {
                                    freqResults.push({
                                        key: value.name,
                                        value: value.id,
                                    });
                                }
                            });

                            setFreqOptions([
                                { key: 'Select Frequency', value: '' },
                                ...freqResults
                            ]);

                            let freqObj = freqResults.filter((singleFreq) => {
                                return Number(singleFreq.value) == Number(fId);
                            })
                            setSelectedFreq(freqObj)

                            /**********************INSTRUCTIONS*****************************/

                            let objInsData = res?.data?.output?.data["special_instruction"];
                            let insResults = [];

                            objInsData?.forEach((value) => {

                                if (value.instruction != null && value.instruction != "") {
                                    insResults.push({
                                        key: value.instruction,
                                        value: value.id,
                                    });
                                }
                            });

                            setSplinsOptions([
                                ...insResults
                            ]);

                            /**********************MED GROUP*****************************/

                            let objMedgroupData = res?.data?.output?.data["medgroup"];
                            let medgroupResults = [];

                            objMedgroupData?.forEach((value) => {

                                if (value.name != null && value.name != "") {
                                    medgroupResults.push({
                                        key: value.name,
                                        value: value.id,
                                    });
                                }
                            });

                            setMedGroupOptions([
                                { key: 'Select MedGroup', value: '' },
                                ...medgroupResults
                            ]);

                            /**********************TIME*****************************/

                            let objHrData = res?.data?.output?.data["prescription_hour"];
                            let hrResults = [];

                            objHrData?.forEach((value) => {

                                if (value.time != null && value.time != "") {
                                    hrResults.push({
                                        key: value.time,
                                        value: value.id,
                                    });
                                }
                            });

                            setTime1([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime2([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime3([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime4([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime5([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime6([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime7([{ key: 'Select Time', value: '' }, ...hrResults]);
                            setTime8([{ key: 'Select Time', value: '' }, ...hrResults]);
                        });
                });
        } else {
            fetchHcpData(localStorage.getItem("facilityId"));
            let prescriptionResults = JSON.parse(localStorage.getItem("prescriptionObjData"));
            let prescriptionResultsforPatient = prescriptionResults?.[locationData1.patientid] || [];
            let presResults = [];
            prescriptionResultsforPatient.forEach((value) => {
                if (value.discontinued_date == null) {
                    presResults.push({
                        key: value.id + '-' + value.drug,
                        value: value.id,
                    });
                }
            });
            setPresOptions([
                { key: 'Select Prescription', value: '' },
                ...presResults
            ]);

            let getAllItems =
            {
                frequency: {},
                special_instruction: {},
                medgroup: {},
                prescription_hour: {}
            };

            await axios.post(`${process.env.REACT_APP_SERVER_URL}/prescriptions/fetch-multiple`, getAllItems, { headers: { 'Authorization': `Bearer ${tokenStr}` } })
                .then(async (res) => {
                    /**********************FREQUENCY*****************************/

                    let objFreqData = res.data.output.data["frequency"];
                    let freqResults = [];

                    objFreqData.forEach((value) => {
                        if (value.name != null && value.name != "") {
                            freqResults.push({
                                key: value.name,
                                value: value.id,
                            });
                        }
                    });

                    setFreqOptions([
                        { key: 'Select Frequency', value: '' },
                        ...freqResults
                    ]);

                    /**********************INSTRUCTIONS*****************************/

                    let objInsData = res.data.output.data["special_instruction"];
                    let insResults = [];

                    objInsData.forEach((value) => {

                        if (value.instruction != null && value.instruction != "") {
                            insResults.push({
                                key: value.instruction,
                                value: value.id,
                            });
                        }
                    });

                    setSplinsOptions([
                        ...insResults
                    ]);

                    /**********************MED GROUP*****************************/

                    let objMedgroupData = res.data.output.data["medgroup"];
                    let medgroupResults = [];

                    objMedgroupData.forEach((value) => {

                        if (value.name != null && value.name != "") {
                            medgroupResults.push({
                                key: value.name,
                                value: value.id,
                            });
                        }
                    });

                    setMedGroupOptions([
                        { key: 'Select MedGroup', value: '' },
                        ...medgroupResults
                    ]);

                    /**********************TIME*****************************/

                    let objHrData = res.data.output.data["prescription_hour"];
                    let hrResults = [];

                    objHrData.forEach((value) => {

                        if (value.time != null && value.time != "") {
                            hrResults.push({
                                key: value.time,
                                value: value.id,
                            });
                        }
                    });

                    setTime1([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime2([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime3([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime4([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime5([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime6([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime7([{ key: 'Select Time', value: '' }, ...hrResults]);
                    setTime8([{ key: 'Select Time', value: '' }, ...hrResults]);
                });
        }


    }

    async function fetchHcpData(facilityid) {

        let tokenStr = localStorage.getItem("accessToken");
        //TODO confirm with SHANKS whether listing is based on facility id or not
        const { data } = await axios.get(`${process.env.REACT_APP_SERVER_URL}` + "/doctors/list-doctors", { headers: { 'Authorization': `Bearer ${tokenStr}` } });
        let results = []

        //console.log("Doctor Data Status " + data.status);
        let objPatientData = data.data;

        objPatientData.forEach((value) => {
            results.push({
                key: value.lastname + ", " + value.firstname,
                value: value.id
            });
        });

        setHcpOptions([
            ...results
        ])

    }

    const requestToggleIsDiscontinued = (nextChecked) => {
        // nextChecked is the switch state user tried to set
        setPendingIsDiscontinued(nextChecked);
        setShowIsDiscModal(true);
    };

    const confirmToggleIsDiscontinued = () => {
        const toDiscontinue = pendingIsDiscontinued === true;
        // IsDiscontinued true  => is_active false (0)
        // IsDiscontinued false => is_active true  (1)
        setFormData(prev => ({ ...prev, is_active: !toDiscontinue }));
        setShowIsDiscModal(false);
        setPendingIsDiscontinued(null);
    };

    const cancelToggleIsDiscontinued = () => {
        setShowIsDiscModal(false);
        setPendingIsDiscontinued(null);
    };


    const handleMedicalRecordModal = (event) => {
        //localStorage.setItem("medicalRecordFormName", event.target.id);
        setShowModal(true);
    };

    const validateForm = () => {
        let newErrors = {};
        if (locationData.medrecord_id != null) {
            if (!formData.facilityname) newErrors.facilityname = "Facility is required";
            if (!formData.individual) newErrors.individual = "Individual is required";
            // if (!formData.orderid) newErrors.orderid = "Prescription is required";
        }
        if (!formData.category) newErrors.category = "Category is required";
        if (!formData.description) newErrors.description = "Description is required";
        if (!startdate) newErrors.startdate = "Start Date is required.";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // Handler
    const handleSubmit = async e => {
        e.preventDefault();

        if (!validateForm()) return;

        if (e.target.name == "medicalrecordform") {
            setLoader(true);

            //console.log("locationData.medrecord_id" + locationData.medrecord_id);

            let tokenStr = localStorage.getItem("accessToken");
            let pelmedsMedicalRecordUrl = locationData.medrecord_id != null ? `${process.env.REACT_APP_SERVER_URL}/patients/update-medical-record` : `${process.env.REACT_APP_SERVER_URL}/patients/add-medical-record`;

            let splInsManual = [];

            splInsOptions.map((splinsoption) => {

                if (splinsoption.value == "-999") {
                    splInsManual.push(splinsoption.key);
                }
            });

            let pelmedsMedicalRecordData = locationData.medrecord_id != null ?
                {
                    id: locationData.medrecord_id,
                    group_id: localStorage.getItem("groupId"),
                    facility_id: formData.facilityname,
                    patient_id: formData.individual,
                    description: formData.description,
                    // start_date: startdate != null ? moment(startdate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
                    // stop_date: stopdate != null ? moment(stopdate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
                    start_date: startdate != null ? moment(startdate).format('YYYY-MM-DD') : null,
                    stop_date: stopdate != null ? moment(stopdate).format('YYYY-MM-DD') : null,
                    medical_record_category_id: formData.category || "",
                    doctor_id: formData.hcp,
                    frequency_id: selectedFreq?.value ? selectedFreq?.value : '',
                    prescription_id: formData.orderid,
                    special_instruction_id: formData.splins,
                    // special_instruction_manual: splInsManual.toString(), showing unknown from server
                    // remarks: formData.callhcp,  showing unknown from server
                    med_group_id: formData.medgrp,
                    reason: formData.rsn,
                    other_note: formData.callhcp,
                    medication_identifier: formData.is_prnmedication ? "P" : "", //Todo why MedType is P
                    mar_flag: formData.is_medsheet ? 1 : 0,
                    tar_flag: formData.is_treatment ? 1 : 0,
                    is_active: formData.is_active ? 1 : 0,
                    po_order: formData.is_physpres ? 1 : 0,
                    time1: !formData.is_prnmedication ? formData.time1 : '0',
                    time2: !formData.is_prnmedication ? formData.time2 : '0',
                    time3: !formData.is_prnmedication ? formData.time3 : '0',
                    time4: !formData.is_prnmedication ? formData.time4 : '0',
                    time5: !formData.is_prnmedication ? formData.time5 : '0',
                    time6: !formData.is_prnmedication ? formData.time6 : '0',
                    time7: !formData.is_prnmedication ? formData.time7 : '0',
                    time8: !formData.is_prnmedication ? formData.time8 : '0'
                } :
                {
                    group_id: localStorage.getItem("groupId"),
                    facility_id: localStorage.getItem("facilityId"),
                    patient_id: localStorage.getItem("patientId"),
                    doctor_id: formData.hcp,
                    description: formData.description,
                    frequency_id: selectedFreq?.value ? selectedFreq?.value : '',
                    prescription_id: formData.orderid,
                    //start_date: startdate != null ? moment(startdate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
                    //stop_date: stopdate != null ? moment(stopdate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null,
                    start_date: startdate != null ? moment(startdate).format('YYYY-MM-DD') : null,
                    stop_date: stopdate != null ? moment(stopdate).format('YYYY-MM-DD') : null,
                    special_instruction_id: formData.splins,
                    special_instruction_manual: splInsManual.toString(),
                    other_note: formData.callhcp,
                    // medgroup_id: formData.medgrp,
                    med_group_id: formData.medgrp,
                    reason: formData.rsn,
                    medication_identifier: formData.is_prnmedication ? "P" : "", //Todo why MedType is P
                    mar_flag: formData.is_medsheet ? 1 : 0,
                    tar_flag: formData.is_treatment ? 1 : 0,
                    is_active: formData.is_active ? 1 : 0,
                    po_order: formData.is_physpres ? 1 : 0,
                    time1: !formData.is_prnmedication ? formData.time1 : '0',
                    time2: !formData.is_prnmedication ? formData.time2 : '0',
                    time3: !formData.is_prnmedication ? formData.time3 : '0',
                    time4: !formData.is_prnmedication ? formData.time4 : '0',
                    time5: !formData.is_prnmedication ? formData.time5 : '0',
                    time6: !formData.is_prnmedication ? formData.time6 : '0',
                    time7: !formData.is_prnmedication ? formData.time7 : '0',
                    time8: !formData.is_prnmedication ? formData.time8 : '0',
                    medical_record_category_id: formData.category || ""
                }

            const { data } = await axios.post(pelmedsMedicalRecordUrl, pelmedsMedicalRecordData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });
            const patientDetails = paths.patientDetails;
            if (data.status && locationData.medrecord_id == null) {
                toast.success("Medical record Details added successfully");
                navigate(`${patientDetails}/${localStorage.getItem("patientId")}`);
                setLoader(false);
                localStorage.setItem("highlightab", "medical-record");
            }
            else if (data.status && locationData.medrecord_id != null) {
                toast.success("Medical record Details updated successfully");
                const params = new URLSearchParams();
                params.append('id', locationData.medrecord_id);
                // navigate(`${patientDetails}/${formData.individual}?${params.toString()}`);
                navigate(`${patientDetails}/${formData.individual}`);
                setLoader(false);
                localStorage.setItem("highlightab", "medical-record");
            }
            else {
                toast.info("Error while adding Medical record Details");
                setLoader(false);
            }

            //if (locationData == null) {
            //    setFormData(initialFormData);
            //    formRef.current.reset();
            //}
            //console.log("DataOutput " + JSON.stringify(data));

        }
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleMedRecordFieldChange = e => {

        //console.log(e.target.value);        

        formData.is_medsheet = e.target.value.split("|")[1] == 0 ? false : true;
        formData.is_treatment = e.target.value.split("|")[2] == 0 ? false : true;
        formData.is_physpres = e.target.value.split("|")[3] == 0 ? false : true;
        const value = e.target.value?.split('|')[0];
        setFormData({
            ...formData,
            [e.target.name]: value
        });

    }

    const handlePrnMedication = (e) => {
        setChecked(!checked);
        setFormData({
            ...formData,
            is_prnmedication: e.target.checked
        });
    };

    const handleMoreTime = (e) => {
        //if (!edittimeclicked)
        setEditTimeClicked(true);
    };

    const handleMedicalRecordModalValue = (modalvalue) => {

        let isDuplicate = handleDrpDuplicates(splInsOptions, modalvalue);
        if (modalvalue != "" && !isDuplicate) {
            let updatedInsOptions = splInsOptions.filter((singleoption) => singleoption.value != -999);
            updatedInsOptions.push({ key: modalvalue, value: -999 });
            setSplinsOptions(updatedInsOptions);
        }

    };

    function handleDrpDuplicates(drpdwnOptions, modalvalue) {

        let isDuplicate = false;

        drpdwnOptions.map((singleoption) => {
            //console.log(singleoption.key + " && " + modalvalue);
            if (singleoption.key.toLowerCase() == modalvalue.toLowerCase()) {
                isDuplicate = true;
            }
        })

        return isDuplicate;
    }

    const validateStopDate = stopdate => {
        if (moment(stopdate) > moment(startdate)) {
            setStopDate(stopdate)
        } else {
            toast.info("Stop date should be greater than Start Date");
        }
    }

    const handleFreqFieldChange = e => {
        setSelectedFreq(e);
        setFormData({
            ...formData,
            'frequency': e.value
        });
    };

    const breadcrumbItems = locationData.medrecord_id != null ? [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Patient', href: paths.viewPatient, isActive: false },
        {
            name: patientName?.split(',')
                .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
                .join(','), href: `${paths.patientDetails}/${formData.individual}`, isActive: false
        },
        { name: 'Edit-Medicalrecord', href: paths.editPrescription, isActive: true }

    ] : [
        { name: 'Dashboard', href: '/main', isActive: false },
        { name: 'Patient', href: paths.viewPatient, isActive: false },
        {
            name: localStorage.getItem("patientName")?.split(',')
                .map(s => s.charAt(0).toUpperCase() + s.slice(1).toLowerCase())
                .join(','), href: `${paths.patientDetails}/${localStorage.getItem("patientName")}`, isActive: false
        },
        { name: 'Add-Medicalrecord', href: paths.addPrescription, isActive: true }
    ]

    return (
        <>
            <CommonBreadCrumb breadcrumbItems={breadcrumbItems} />
            {showShimmer ? <ShimmerUI /> : <Form onSubmit={handleSubmit} name="medicalrecordform">
                <Card className="mb-3">
                    <Card.Header as="h6" className="bg-body-tertiary">
                        {locationData.medrecord_id != null ? "Edit" : "Add"} Medical Record
                    </Card.Header>
                    <Card.Body>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group>
                                    <Form.Label className='required'>Facility</Form.Label>
                                    <Form.Select
                                        name="facilityname"
                                        onChange={handleFieldChange}
                                        size="sm"
                                        disabled="disabled"
                                    >
                                        {facilityoptions.map((option) => {
                                            let isFacilitySelected = false;
                                            let facilityNameBase = formData.facilityname ? formData.facilityname : localStorage.getItem("facilityId");
                                            if (option.value == facilityNameBase) {
                                                isFacilitySelected = "selected";
                                            }
                                            return (
                                                <option key={option.value} value={option.value} selected={isFacilitySelected} >
                                                    {option.key}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label className='required'>Category</Form.Label>
                                    <Form.Select
                                        name="category"
                                        onChange={handleMedRecordFieldChange}
                                        size="sm"
                                        isInvalid={!!errors.category}
                                        disabled={disableDFlag}
                                    >
                                        {medcategoryOptions.map((option) => {
                                            let isMedRecordCategorySelected = false;
                                            if (Number(option?.value?.split('|')[0]) === formData.category) {
                                                isMedRecordCategorySelected = "selected";
                                            }
                                            return (
                                                <option key={option.value} value={option.value} selected={isMedRecordCategorySelected} >
                                                    {option.key}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid" >{errors.category}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group>
                                    <Form.Label className='required'>Individual</Form.Label>
                                    <Form.Control
                                        name="individual"
                                        onChange={handleFieldChange}
                                        size="sm"
                                        value={patientName}
                                        disabled="disabled">
                                    </Form.Control>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>HCP</Form.Label>
                                    <Form.Select
                                        name="hcp"
                                        onChange={handleFieldChange}
                                        size="sm"
                                        disabled={disableDFlag}>
                                        <option key="Select Hcp" value="">Choose Facility to Select HCP</option>
                                        {hcpoptions.map((option) => {
                                            var isHcpSelected = false;
                                            if (locationData.medrecord_id != null) {
                                                if (option.value == formData.hcp) {
                                                    isHcpSelected = "selected";
                                                }
                                            }
                                            return (
                                                <option key={option.value} value={option.value} selected={isHcpSelected}>
                                                    {option.key}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group>
                                    <Form.Label>Frequency</Form.Label>
                                    <ThemedSelect
                                        name="frequency"
                                        closeMenuOnSelect={true}
                                        placeholder="Select frequency"
                                        classNamePrefix="react-select"
                                        options={freqOptions}
                                        value={selectedFreq}
                                        getOptionLabel={(option) => option.key}
                                        getOptionValue={(option) => option.value}
                                        onChange={handleFreqFieldChange}
                                        isDisabled={disableDFlag}
                                    />
                                    {/* <Form.Select
                                    name="frequency"
                                    onChange={handleFieldChange}
                                >
                                    {freqOptions.map((freqoption) => {
                                        var isFreqSelected = false;
                                        if (locationData.medrecord_id != null) {
                                            if (freqoption.value == formData.frequency) {
                                                isFreqSelected = "selected";
                                            }
                                        }
                                        return (
                                            <option key={freqoption.value} value={freqoption.value} selected={isFreqSelected}>
                                                {freqoption.key}
                                            </option>
                                        );
                                    })}
                                </Form.Select> */}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Prescription</Form.Label>
                                    <Form.Select
                                        name="orderid"
                                        onChange={handleFieldChange}
                                        disabled={disableDFlag}
                                    >
                                        {presOptions.map((presoption) => {
                                            var isPresSelected = false;
                                            if (locationData.medrecord_id != null) {
                                                if (presoption.value == formData.orderid) {
                                                    isPresSelected = "selected";
                                                }
                                            }
                                            return (
                                                <option key={presoption.value} value={presoption.value} selected={isPresSelected}>
                                                    {presoption.key}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Reason</Form.Label>
                                    <Form.Control
                                        placeholder='Reason'
                                        value={formData.rsn}
                                        name="rsn"
                                        onChange={handleFieldChange}
                                        type="text"
                                        size="sm"
                                        disabled={disableDFlag}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row >
                            <Col>
                                {!checked && (
                                    <Form.Group>
                                        <Form.Label>Hour</Form.Label>
                                        <Row>
                                            <Col>
                                                <Form.Select
                                                    name="time1"
                                                    size="xs"
                                                    onChange={handleFieldChange}
                                                    value={formData.time1}
                                                    disabled={disableDFlag}
                                                >
                                                    {time1options.map((time1option) => (
                                                        <option key={time1option.value} value={time1option.value}>
                                                            {time1option.key}
                                                        </option>
                                                    ))}
                                                </Form.Select>

                                                {edittimeclicked && (
                                                    <Form.Select
                                                        className="mt-2"
                                                        name="time5"
                                                        size="xs"
                                                        onChange={handleFieldChange}
                                                        value={formData.time5}
                                                        disabled={disableDFlag}
                                                    >
                                                        {time5options.map((time5option) => (
                                                            <option key={time5option.value} value={time5option.value}>
                                                                {time5option.key}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                )}
                                            </Col>
                                            <Col>
                                                <Form.Select
                                                    name="time2"
                                                    size="xs"
                                                    onChange={handleFieldChange}
                                                    value={formData.time2}
                                                    disabled={disableDFlag}
                                                >
                                                    {time2options.map((time2option) => (
                                                        <option key={time2option.value} value={time2option.value}>
                                                            {time2option.key}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                                {edittimeclicked && (
                                                    <Form.Select
                                                        className="mt-2"
                                                        name="time6"
                                                        size="xs"
                                                        onChange={handleFieldChange}
                                                        value={formData.time6}
                                                        disabled={disableDFlag}
                                                    >
                                                        {time6options.map((time6option) => (
                                                            <option key={time6option.value} value={time6option.value}>
                                                                {time6option.key}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                )}
                                            </Col>
                                            <Col>
                                                <Form.Select
                                                    name="time3"
                                                    size="xs"
                                                    onChange={handleFieldChange}
                                                    value={formData.time3}
                                                    disabled={disableDFlag}
                                                >
                                                    {time3options.map((time3option) => (
                                                        <option key={time3option.value} value={time3option.value}>
                                                            {time3option.key}
                                                        </option>
                                                    ))}
                                                </Form.Select>

                                                {edittimeclicked && (
                                                    <Form.Select
                                                        className="mt-2"
                                                        name="time7"
                                                        size="xs"
                                                        onChange={handleFieldChange}
                                                        value={formData.time7}
                                                        disabled={disableDFlag}
                                                    >
                                                        {time7options.map((time7option) => (
                                                            <option key={time7option.value} value={time7option.value}>
                                                                {time7option.key}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                )}
                                            </Col>
                                            <Col>
                                                <Form.Select
                                                    name="time4"
                                                    size="xs"
                                                    onChange={handleFieldChange}
                                                    value={formData.time4}
                                                    disabled={disableDFlag}
                                                >
                                                    {time4options.map((time4option) => (
                                                        <option key={time4option.value} value={time4option.value}>
                                                            {time4option.key}
                                                        </option>
                                                    ))}
                                                </Form.Select>

                                                {edittimeclicked && (
                                                    <Form.Select
                                                        className="mt-2"
                                                        name="time8"
                                                        size="xs"
                                                        onChange={handleFieldChange}
                                                        value={formData.time8}
                                                        disabled={disableDFlag}
                                                    >
                                                        {time8options.map((time8option) => (
                                                            <option key={time8option.value} value={time8option.value}>
                                                                {time8option.key}
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                )}
                                            </Col>
                                            <Col>
                                                <Button
                                                    variant="outline-secondary"
                                                    id="btnmoretime"
                                                    onClick={handleMoreTime}
                                                    disabled={disableDFlag}
                                                >
                                                    +
                                                </Button>
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                )}
                            </Col>
                            <Col xs="2">
                                <Form.Label></Form.Label>
                                <Form.Check
                                    type='switch'
                                    name="is_prnmedication"
                                    id='is_prnmedication'
                                    disabled={disableDFlag}
                                    checked={
                                        formData.is_prnmedication
                                    }
                                    onChange={handlePrnMedication}
                                    label='Check this Box For PRN Medications'
                                />
                            </Col>
                        </Row>
                        <Row className="mb-2 mt-2">
                            <Col>
                                <Form.Group>
                                    <Form.Label className='required'>Start</Form.Label>
                                    {/* <DatePicker name="startdate" selected={startdate} onChange={(startdate) => setStartDate(startdate)}
                                    className={`form-control form-control-sm ${errors.startdate ? 'is-invalid' : ''}`} placeholderText="Select Start Date" /> */}

                                    <DatePicker
                                        disabled={disableDFlag}
                                        name="startdate"
                                        selected={startdate ? moment(startdate).format("MM/DD/YY") : null}
                                        onChange={(startdate) => setStartDate(startdate)}
                                        dateFormat="MM/dd/yy"
                                        className={`form-control form-control-sm ${errors.startdate ? 'is-invalid' : ''}`} placeholderText="Select Start Date" />


                                    {errors.startdate && <div className="invalid-feedback mt-1 display-block">{errors.startdate}</div>}
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Stop</Form.Label>
                                    {/* <DatePicker name="stopdate" selected={stopdate} onChange={validateStopDate}
                                    className='form-control' placeholderText="Select Stop Date" /> */}

                                    <DatePicker
                                        disabled={disableDFlag}
                                        name="stopdate"
                                        selected={stopdate ? moment(stopdate).format("MM/DD/YY") : null}
                                        onChange={validateStopDate}
                                        className='form-control'
                                        placeholderText="Select Stop Date"
                                        dateFormat="MM/dd/yy"
                                        minDate={new Date()}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group>
                                    <Form.Label>Special Instruction</Form.Label>
                                    <SpecialInstructionInput
                                        disabled={disableDFlag}
                                        value={formData.splins || formData.special_instruction_text}
                                        splInsOptions={splInsOptions}
                                        formData={formData}
                                        setFormData={setFormData}
                                        handlePrescriptionModal={handleMedicalRecordModal}
                                        errors={errors}
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Med Group</Form.Label>
                                    <Form.Select
                                        name="medgrp"
                                        onChange={handleFieldChange}
                                        disabled={disableDFlag}
                                    >
                                        {medgroupOptions.map((medgrpoption) => {
                                            var isMedGroupSelected = false;
                                            if (locationData.medrecord_id != null) {
                                                if (medgrpoption.value == formData.medgrp) {
                                                    isMedGroupSelected = "selected";
                                                }
                                            }
                                            return (
                                                <option key={medgrpoption.value} value={medgrpoption.value} selected={isMedGroupSelected}>
                                                    {medgrpoption.key}
                                                </option>
                                            );
                                        })}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mb-2">
                            <Col>
                                <Form.Group>
                                    <Form.Label>Call HCP If</Form.Label>
                                    <Form.Control
                                        disabled={disableDFlag}
                                        placeholder='Call HCP If'
                                        value={formData.callhcp}
                                        name="callhcp"
                                        onChange={handleFieldChange}
                                        type="text"
                                        size="sm"
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label className='required'>Description</Form.Label>
                                    <Form.Control
                                        disabled={disableDFlag}
                                        placeholder='Description'
                                        value={formData.description}
                                        name="description"
                                        onChange={handleFieldChange}
                                        type="text"
                                        size="sm"
                                        isInvalid={!!errors.description}
                                    />
                                    <Form.Control.Feedback type="invalid" >{errors.description}</Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row className="mt-4">
                            <Col>
                                <Form.Check
                                    type='switch'
                                    name="is_medsheet"
                                    id='is_medsheet'
                                    disabled={disableDFlag}
                                    checked={
                                        formData.is_medsheet
                                    }
                                    onChange={(e) => {
                                        if (formData.is_medsheet && !e.target.checked) {
                                            if (!window.confirm("Are you sure you want to turn off Medsheet?")) {
                                                return;
                                            }
                                        }
                                        setFormData({
                                            ...formData,
                                            is_medsheet: e.target.checked,
                                        });
                                    }}
                                    label='Medsheet'
                                />
                            </Col>
                            <Col>
                                <Form.Check
                                    type='switch'
                                    name="is_treatment"
                                    id='is_treatment'
                                    disabled={disableDFlag}
                                    checked={
                                        formData.is_treatment
                                    }
                                    onChange={e =>
                                        setFormData({
                                            ...formData,
                                            is_treatment: e.target.checked
                                        })
                                    }
                                    label='Treatment'
                                />
                            </Col>
                            <Col>
                                <Form.Check
                                    type='switch'
                                    name="is_physpres"
                                    id='is_physpres'
                                    disabled={disableDFlag}
                                    checked={
                                        formData.is_physpres
                                    }
                                    onChange={e =>
                                        setFormData({
                                            ...formData,
                                            is_physpres: e.target.checked
                                        })
                                    }
                                    label='Physician Prescription'
                                />
                            </Col>
                            {/* <Col>
                                <Form.Check
                                    type="switch"
                                    name="is_active"
                                    id="is_active"
                                    checked={!formData.is_active}
                                    onChange={(e) => requestToggleIsDiscontinued(e.target.checked)}
                                    label="Is Discontinued"
                                />
                            </Col> */}
                        </Row>
                        <Row>
                            <Col></Col>
                            <Col>
                                {loader ? (
                                    <div className="d-flex justify-content-center align-items-center" style={{ height: '38px' }}>
                                        <Spinner animation="border" role="status" />
                                    </div>
                                ) : (
                                    <Form.Group>
                                        <Button
                                            type="submit"
                                            color="primary"
                                            className="w-100 mt-4">
                                            {locationData.medrecord_id != null ? "Update" : "Save"}
                                        </Button>
                                    </Form.Group>)}
                            </Col>
                            <Col></Col>
                        </Row>
                    </Card.Body>
                </Card>
                {showIsDiscModal && <Modal show={showIsDiscModal} onHide={cancelToggleIsDiscontinued} centered backdrop="static">
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {pendingIsDiscontinued ? 'Mark as discontinued?' : 'Mark as active?'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {pendingIsDiscontinued
                            ? 'This will discontinue medical record. Continue?'
                            : 'This will mark the medical record as active again. Continue?'}
                    </Modal.Body>
                    <Modal.Footer>
                        <button type="button" className="btn btn-outline-secondary" onClick={cancelToggleIsDiscontinued}>
                            Cancel
                        </button>
                        <button
                            type="button"
                            className={`btn ${pendingIsDiscontinued ? 'btn-danger' : 'btn-success'}`}
                            onClick={confirmToggleIsDiscontinued}
                        >
                            Confirm
                        </button>
                    </Modal.Footer>
                </Modal>}

                <MedicalRecordModal show={showModal} setShow={setShowModal} handleMedicalRecordModalValue={handleMedicalRecordModalValue} />
            </Form >}
        </>
    );
};

AddEditMedicalRecord.propTypes = {
    layout: PropTypes.string,
    hasLabel: PropTypes.bool
};

AddEditMedicalRecord.defaultProps = {
    layout: 'simple',
    hasLabel: false
};

export default AddEditMedicalRecord;